import { Component } from 'react';
import { computed } from 'mobx';
import { Theme } from '../../models/Theme';
import { DataStore } from '../../stores';

export interface ThemeableProps<T> {
    dataStore?: DataStore;
    theme?: Theme;
    themeKeys?: T;
}

export abstract class ThemeableComponent<
    TProps = {},
    TState = {},
    TThemeKeys = {}
> extends Component<TProps & ThemeableProps<TThemeKeys>, TState> {
    protected DEFAULT_THEME_KEYS: TThemeKeys = {} as TThemeKeys;

    @computed
    protected get breakpoints() {
        return this.props?.dataStore?.theme?.breakpoints;
    }

    protected get themeKeys(): TThemeKeys {
        return this.props.themeKeys;
    }

    protected getThemeKeyOrDefault(key: keyof TThemeKeys): string {
        if (this.themeKeys && this.themeKeys[key]) {
            return this.themeKeys[key as string];
        }
        if (this.DEFAULT_THEME_KEYS && this.DEFAULT_THEME_KEYS[key]) {
            return this.DEFAULT_THEME_KEYS[key as string];
        }
        return;
    }

    protected getTheme(key: keyof TThemeKeys) {
        const { theme } = this.props;
        const themeKey = this.getThemeKeyOrDefault(key);
        if (themeKey && theme && theme[themeKey]) {
            return theme[themeKey];
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/theme/ThemeableComponent.tsx